export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14512.c6e170cf.jpg";